import { _axios } from '@/plugins/axios';

const resource = '/api/v1/sac-templates';

export default {
  getAll: () => _axios.get(`${resource}/all`),
  getById: id => _axios.get(`${resource}/${id}`),
  create: dto => _axios.post(`${resource}/create`, dto),
  update: (id, dto) => _axios.put(`${resource}/update/${id}`, dto),
  remove: id => _axios.delete(`${resource}/delete/${id}`),
};
